import React from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  return (
    <header className="py-4 px-6 bg-white shadow-sm mb-6">
      <div className="container mx-auto">
        <Link to="/" className="inline-block">
          <img 
            src="/logo-orpi.png" 
            alt="Logo ORPI" 
            className="h-12"
          />
        </Link>
      </div>
    </header>
  );
};

export default Header;